import {
    minimizedChatIconActions, webChatMinimizedIcon
} from '../../supportTicket/supportWindow';

export class EventBankOpenedHandler {
    public handle(): void {
        minimizedChatIconActions(webChatMinimizedIcon.HIDE);
        window.helpshiftWebChatState.hideChatIcon = true;
        // eslint-disable-next-line new-cap
        window.Helpshift('close');
    }
}
